module.exports = __webpack_public_path__ + "img/masks.f46c9cde.svg";